import { Column } from "@tanstack/react-table";
import { ArrowDown, ArrowUp, ChevronsUpDown } from "lucide-react";

import { cn } from "@/lib/utils";
import { SORT_DEFAULT_DESC } from "../constants";

interface DataTableColumnHeaderProps<TData, TValue> {
  column: Column<TData, TValue>;
  title: string;
  className?: string;
}

export function DataTableColumnHeader<TData, TValue>({
  column,
  title,
  className,
}: DataTableColumnHeaderProps<TData, TValue>): JSX.Element {
  if (!column.getCanSort()) {
    return <div className={cn(className)}>{title}</div>;
  }

  const defaultDesc: boolean = SORT_DEFAULT_DESC[column.id] ?? false;
  const currentSort: false | "asc" | "desc" = column.getIsSorted();

  const toggleSorting = (): void => {
    if (!currentSort) {
      column.toggleSorting(defaultDesc);
      return;
    }
    column.toggleSorting(currentSort === "asc");
  };

  return (
    <button
      type="button"
      onClick={toggleSorting}
      aria-label={`Ordenar por ${title}`}
      className={cn(
        "-ml-1 flex items-center gap-2 rounded px-1 py-1 font-medium text-gray-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#613F4F]",
        className,
      )}
    >
      <span>{title}</span>
      {currentSort === "desc" ? (
        <ArrowDown className="h-3.5 w-3.5" />
      ) : currentSort === "asc" ? (
        <ArrowUp className="h-3.5 w-3.5" />
      ) : (
        <ChevronsUpDown className="h-3.5 w-3.5" />
      )}
    </button>
  );
}
